import {useState, useId} from "react";
import {Container, Col, Input, FormText, Button} from "reactstrap";
import {PhoneValidator} from "../../shared/Validators";
import {App} from "../App";
import {SessionReload} from "../AppHelpers";
import {Api} from "../../shared";

export const ChangePhone = ({user}: {user: Api.Auth.UserType}) =>
{
	const [phone, setPhone] = useState(user.phone);
	const [errors, setErrors] = useState("");

	const click = async () =>
	{
		let errors_n = "";

		switch(PhoneValidator(phone))
		{
			case "InvalidCharacters":
				errors_n = "Illegal characters";
				break;
			case "Required":
				errors_n = "Value is required";
				break;
			case "TooLong":
				errors_n = "Value is too big";
				break;
			case "Valid":
				errors_n = "";
				break;
		}

		if(phone === user.phone)
		{
			errors_n = "Value unchanged";
		}

		if(errors_n === "")
		{
			let res = await Api.Auth.Call.changePhone({
				phone: phone
			});

			if(res.error !== undefined)
			{
				switch(res.error)
				{
					case "not logged in":
						errors_n = "Not logged in";
						break;
					case "unauthorised":
						errors_n = "Unauthorised";
						break;
					default:
						throw res.error;
				}
			}
		}

		setErrors(errors_n);

		if(errors_n === "")
		{
			await SessionReload();

			App.open(null);
		}
	}

	const id1 = useId();
	const id2 = useId();

	return (
		<Container aria-labelledby={id1}>
			<Col><h4 id={id1}>Change Phone Number</h4></Col>
			<Col>
				<label htmlFor={id2} className="visually-hidden">New phone number</label>
				<Input id={id2} placeholder="Your Phone" defaultValue={phone} onChange={(e) => setPhone(e.target.value)} />
				<FormText color="danger">{errors}</FormText>
			</Col>
			<Col className="spacer">
				<Button onClick={click}>Ok</Button>
				<Button onClick={() => App.open(null)}>Cancel</Button>
			</Col>
		</Container>
	);
}
